// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSRegisteredProcess/process.less
// module id = 944
// module chunks = 42